import React from 'react';
import classNames from 'classnames';
import { SortDirection } from '../models/sortDirection';
import './SortIndicator.scss';

export default function SortIndicator(props: { sortDirection: SortDirection | nundefined; sortClicked: () => void; }) {
	return (
		<div onClick={props.sortClicked}
			 tabIndex={0}
			 className={classNames('sort-indicator', {'sort-indicator_asc': props.sortDirection === 'asc', 'sort-indicator_desc': props.sortDirection === 'desc'})}></div>
	);
}
